module.exports = __webpack_public_path__ + "img/logossg.e641a71a.png";